export const selectAssetsStatusIds = state => state.entities.assets.domains.status.ids;

export const selectIsLoadingAssetStatus = state => state.entities.assets.domains.status.isLoading;
